<template lang="pug">
section.section-content.section-content--browsing-data-usage
    .box
        header.flex.items-center.justify-between.box__header.no-border
            .header-meta
                h2.subheading Data Usage
            .header-cta

        .box__body
            .box-tabs
                vue-tabs
                    v-tab(title="Domains")
                        dataUsageDomain

                    v-tab(title="App Categories")
                        dataUsageAppCategories
                    
                    v-tab(title="Web Categories")
                        dataUsageWebCategories
                    
                    v-tab(title="Host Name")
                        dataUsageHostName
                    
                    v-tab(title="Referer Domain")
                        dataUsageRefererDomain
                    
                    v-tab(title="Referer URL")
                        dataUsageRefererUrl
</template>

<script>
import {VueTabs, VTab} from 'vue-nav-tabs'

import dataUsageDomain from './../browsing/dataUsage/Domain.vue'
import dataUsageAppCategories from './../browsing/dataUsage/AppCategories.vue'
import dataUsageWebCategories from './../browsing/dataUsage/WebCategories.vue'
import dataUsageHostName from './../browsing/dataUsage/HostName.vue'
import dataUsageRefererDomain from './../browsing/dataUsage/RefererDomain.vue'
import dataUsageRefererUrl from './../browsing/dataUsage/RefererUrl.vue'

export default {
    name: 'HistoryBrowsingDataUsage',
    components: {
        VueTabs,
        VTab,
        dataUsageDomain,
        dataUsageAppCategories,
        dataUsageWebCategories,
        dataUsageHostName,
        dataUsageRefererDomain,
        dataUsageRefererUrl,
    },
}
</script>

<style lang="sass">

</style>
